<ps-menu></ps-menu>
<router-outlet></router-outlet>